module.exports = __webpack_public_path__ + "static/media/starfighter-alt.1e299fe2.svg";